import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { postData } from "../../../FetchApiServices";
import { addUser } from "../../../react-redux/Slicer/userSlice";
import "../T2T.css";

const T2TChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user     = useSelector((state) => state?.user?.users[0]);

  const [newPassword, setNewPassword]       = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError]   = useState("");
  const [saving, setSaving] = useState(false);

  const validate = () => {
    if (!newPassword) return "Please enter a new password.";
    if (newPassword.length < 8) return "Password must be at least 8 characters.";
    if (!/[A-Z]/.test(newPassword)) return "Password must contain at least one uppercase letter.";
    if (!/\d/.test(newPassword)) return "Password must contain at least one number.";
    if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(newPassword)) return "Password must contain at least one special character.";
    if (newPassword !== confirmPassword) return "Passwords do not match.";
    return null;
  };

  const handleSubmit = async () => {
    const err = validate();
    if (err) { setError(err); return; }
    setError("");
    setSaving(true);

    const resp = await postData("users/me/change-password", {
      new_password: newPassword,
    });

    if (resp.error) {
      setError(resp.error.message || "Failed to change password.");
      setSaving(false);
      return;
    }

    // Update user in Redux to clear must_change_password flag
    if (user) {
      dispatch(addUser({ ...user, must_change_password: false }));
    }

    setSaving(false);
    navigate("/t2t-home");
  };

  return (
    <div className="t2t-module" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--t2t-bg)" }}>
      <div style={{ width: "100%", maxWidth: 420, padding: 32 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🔐</div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: "var(--t2t-text-primary)", marginBottom: 4 }}>Change Your Password</h1>
          <p style={{ fontSize: 13, color: "var(--t2t-text-secondary)" }}>
            You must set a new password before continuing. This is required on first login.
          </p>
        </div>

        <div style={{ background: "var(--t2t-surface)", border: "1px solid var(--t2t-border)", borderRadius: "var(--t2t-radius-lg)", padding: 24 }}>
          {error && (
            <div style={{ padding: "10px 14px", background: "#FEF2F2", color: "#DC2626", borderRadius: 8, fontSize: 12, marginBottom: 16 }}>
              {error}
            </div>
          )}

          <div className="t2t-fg">
            <label>New Password *</label>
            <input
              className="t2t-fc"
              type="password"
              value={newPassword}
              onChange={(e) => { setNewPassword(e.target.value); if (error) setError(""); }}
              placeholder="Min 8 chars, uppercase, number, special char"
            />
          </div>

          <div className="t2t-fg">
            <label>Confirm Password *</label>
            <input
              className="t2t-fc"
              type="password"
              value={confirmPassword}
              onChange={(e) => { setConfirmPassword(e.target.value); if (error) setError(""); }}
              placeholder="Re-enter your new password"
            />
          </div>

          {/* Password rules checklist */}
          <div style={{ marginBottom: 16, fontSize: 11, lineHeight: 1.8 }}>
            <div style={{ color: newPassword.length >= 8 ? "#16A34A" : "#94A3B8" }}>{newPassword.length >= 8 ? "✓" : "○"} At least 8 characters</div>
            <div style={{ color: /[A-Z]/.test(newPassword) ? "#16A34A" : "#94A3B8" }}>{/[A-Z]/.test(newPassword) ? "✓" : "○"} One uppercase letter</div>
            <div style={{ color: /\d/.test(newPassword) ? "#16A34A" : "#94A3B8" }}>{/\d/.test(newPassword) ? "✓" : "○"} One number</div>
            <div style={{ color: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(newPassword) ? "#16A34A" : "#94A3B8" }}>{/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(newPassword) ? "✓" : "○"} One special character</div>
            <div style={{ color: newPassword && newPassword === confirmPassword ? "#16A34A" : "#94A3B8" }}>{newPassword && newPassword === confirmPassword ? "✓" : "○"} Passwords match</div>
          </div>

          <button
            className="t2t-btn t2t-btn-primary t2t-btn-lg t2t-btn-block"
            onClick={handleSubmit}
            disabled={saving}
          >
            {saving ? "Updating..." : "Set New Password →"}
          </button>
        </div>

        <div style={{ textAlign: "center", marginTop: 16, fontSize: 11, color: "#94A3B8" }}>
          Hi, {user?.name || "User"} — you are logged in as {user?.email || ""}
        </div>
      </div>
    </div>
  );
};

export default T2TChangePassword;
